import { core as appClientCore } from '@edf-pkg/app-client';

import { axios } from '$app-web/api/axios';
import { ActivitySession, Session } from '$app-web/types';

import { Endpoints } from '../constant';

export async function createActivitySession(params: {
    activityId: number;
    tlId: number;
    deviceId?: string;
    urlVariables?: Record<string, string>;
}) {
    const formData = new FormData();

    formData.append('tl_id', params.tlId.toString());
    formData.append('activity_id', params.activityId.toString());
    if (params.deviceId != null) {
        formData.append('device_id', params.deviceId);
    }
    if (params.urlVariables != null) {
        formData.append('url_variables', JSON.stringify(params.urlVariables));
    }

    try {
        const { data } = await axios.post<Session>(`${Endpoints.Activity.Create}`, formData, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        });

        return data;
    } catch (error) {
        appClientCore.errorMapper(error as Error);
        throw error;
    }
}

export async function fetchActivitySession(sessionUuid: string) {
    const { data } = await axios.get('/api/study/activity/session/', {
        params: { session_uuid: sessionUuid, activity_type: 'survey' },
    });

    // The old endpoint returns a flat structure with session fields at top level.
    // Restructure to match ActivitySession format expected by the consumer.
    const { activity, responses, ...session } = data;
    return { session, activity, responses } as ActivitySession;
}
